/**
 * PhoneInput - Auto-formatting phone field for large bond forms
 * Formats to (XXX) XXX-XXXX on blur, strips to digits on focus.
 */

import { useState } from 'react';

const formatPhone = (val) => {
  if (!val) return '';
  const cleaned = val.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  if (cleaned.length === 11) {
    return `${cleaned[0]} (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  return cleaned;
};

const PhoneInput = ({ label, value, onChange, placeholder = 'Phone number', required, disabled, className = '' }) => {
  const [focused, setFocused] = useState(false);

  const displayValue = focused ? value : formatPhone(value);

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <input
        type="text"
        inputMode="tel"
        value={displayValue}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 11))}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        data-1p-ignore
        data-lpignore="true"
        className="w-full px-4 py-3.5 border rounded-xl text-base sm:text-sm bg-white dark:bg-gray-700 dark:text-white focus:ring-2 focus:ring-primary/20 focus:border-primary disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed transition-all duration-200 placeholder:text-gray-400 dark:placeholder:text-gray-500 border-gray-300 dark:border-gray-600"
      />
    </div>
  );
};

export default PhoneInput;
